const INDEXABLE_LEGACY_PROFILE_USERNAMES = new Set([
  "ecologi",
  "workaway",
  "tiltingpoint",
  "glasdoninternational",
  "varietyfuneralslimit",
  "render",
  "rainbowcosmeticsmanchesterltd",
  "breakerlink",
  "capgemini",
  "sutsu",
  "castletrustbank",
  "ademtisoftware",
  "ecosensecleaning",
  "yourcompanyformation",
  "version1",
  "topfurniture",
  "trainpal",
  "birleafurnitureltd",
  "yourcoop",
  "hitachisolutions",
  "dcadvisory",
  "sanctuary",
  "eco-u",
  "letsplanttrees",
  "glasdonuk",
  "all-emissions",
  "anglodoorstepcollect",
  "semi-forest",
  "p4solar",
]);

export const isIndexableLegacyProfile = (username?: string | null) =>
  !!username && INDEXABLE_LEGACY_PROFILE_USERNAMES.has(username.toLowerCase());
